import { setEditor } from 'reactApp/modules/editor/editor.saga';
import { watchFreezeUser } from 'reactApp/modules/freeze/freeze.saga';
import { setTree } from 'reactApp/modules/home/home.saga';
import { watchFbUser } from 'reactApp/modules/recovery/fbRecovery.saga';
import { initConsoleApi, reportFeatures, setQueryParams } from 'reactApp/modules/settings/settings.saga';
import { socialUserConfirmEmail } from 'reactApp/modules/socialUser/socialUser.saga';
import { initSortSaga } from 'reactApp/modules/sort/sort.saga';
import { checkContinueUpload } from 'reactApp/modules/uploadList/continueUpload/continueUpload.saga';
import { call, fork } from 'redux-saga/effects';

export function* initSagas() {
    yield fork(watchFbUser);
    yield fork(watchFreezeUser);
    yield call(setQueryParams);
    yield fork(setEditor);
    yield call(setTree);
    yield call(initSortSaga); // TODO: routing: now it is for home only
    yield call(checkContinueUpload);
    yield fork(socialUserConfirmEmail);
    yield call(initConsoleApi);
    yield call(reportFeatures);
}
